import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { withRouter } from "react-router"
import isNumber from "lodash/isNumber"

import config from "../Config"
import i18n from "../i18n"

const Container = styled.div`
  display: flex;
  height: 56px;
  color: #fff;
  display: flex;
  align-items: center;
`

const Label = styled.span`
  font-family: montserratRegular;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  flex: 3;
`

const Text = styled.span`
  font-size: ${(props) => `${props.size}px`};
  font-family: montserratLight;
  color: #fff;
`

var PageHeader = ({
  label,
  history,
  backLocation,
  style,
  freeBids,
  bidBalance,
  handleInvite,
  theme,
}) => {
  let closeOption = false
  if (backLocation === "Landing") {
    closeOption = true
    backLocation = false
  }
  console.log("Page Header : ", label, i18n.t(label))
  console.log(" Back Button : ", backLocation, closeOption)
  console.log("history", history)
  return (
    <Container
      style={{ ...style, backgroundColor: theme ? theme.primaryColor : "#000" }}
      className='setWidth'
    >
      {backLocation && (
        <div style={{ width: 60 }} className='flex-center'>
          <img
            width='24px'
            height='24px'
            // onClick={() => history.push(backLocation)}
            onClick={() => history.goBack()}
            className='pointer'
            src={`${config.MRBIDNWIN_S3_IMAGE_URL}/arrow_back.svg`}
            alt='back-arrow'
          />
        </div>
      )}

      {closeOption && (
        <div style={{ width: 60 }} className='flex-center'>
          <img
            width='24px'
            height='24px'
            onClick={() => window.close()}
            className='pointer'
            src={`${config.MRBIDNWIN_S3_IMAGE_URL}/arrow_back.svg`}
            alt='back-arrow'
          />
        </div>
      )}

      <Label>{i18n.t(label.trim().replace(/\s/g, ""))}</Label>
      {/* {freeBids && (
        <div className='free-bids' onClick={handleInvite}>
          {i18n.t("FreeBids")}
        </div>
      )} */}
      {isNumber(bidBalance) && (
        <Text style={{ marginRight: 20 }} size={16}>
          <b>{bidBalance}</b>{" "}
          <Text size={14}>{`${i18n.t("Bid")}${bidBalance > 1 && "s"}`}</Text>
        </Text>
      )}
    </Container>
  )
}

PageHeader.defaultProps = {
  style: {},
}

PageHeader.propTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
  handleInvite: PropTypes.func,
  freeBids: PropTypes.bool,
  bidBalance: PropTypes.number,
}

export default withRouter(PageHeader)



// WEBPACK FOOTER //
// ./src/views/PageHeader.js